// types
import { createSlice } from '@reduxjs/toolkit';
import { MenuProps } from 'types/slices/slices';

// initial state
const getInitialState = () => {
    const drawerOpen = localStorage.getItem('drawerOpen') === 'true';
    return {
        selectedItem: ['dashboard'],
        drawerOpen
    };
};

const initialState: MenuProps = getInitialState();

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.selectedItem = action.payload;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload;
            localStorage.setItem('drawerOpen', action.payload);
        }
    }
});

export default menu.reducer;

export const { activeItem, openDrawer } = menu.actions;
